import React from "react";
import { Box, Typography } from "@mui/material";
import "../../../colors.css";

export default function ConfirmEmail() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Typography variant="h2" style={{ color: "var(--black)" }}>
        GRAZIE
      </Typography>
      <Typography variant="h6" style={{ color: "var(--black)" }}>
        Controlla la tua email per confermare la registrazione
      </Typography>
      {/* <Link to="/login">Torna al Login</Link> */}
    </Box>
  );
}
